import React from 'react';
import './login.css';
import LoginForm from './LoginForm';


const Code: React.FC = () => {

  return (
    <div className='page-container-alt'>
        <LoginForm type={0}/>
    </div>
  );
};

export default Code;
